import { css, styled } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";

export const StyledMuiDatePicker = styled(MobileDatePicker)<{iconOnly?:boolean}>`
  .MuiOutlinedInput-root {
    border-radius: 10px;
    background-color: ${props => props.theme.palette.bottomColor.main};
  }
  .Mui-disabled{

    cursor: not-allowed
  }
  
  ${props => props.disabled ? css`
  .MuiInputAdornment-root {
    color:  ${props.theme.palette.fontColor.main}80;
  } 
  ` : undefined}
  ${props => props.iconOnly ? css`
    .MuiOutlinedInput-root {
      height: 40px;
      width: 40px;
      padding: 0;
      
      input {
        display: none;
      }
    }
    .MuiInputAdornment-root {
      width: 100%;
      height: 100%;
      margin-left: 0;
      justify-content: center;

      svg {
        font-size: 1.2rem;
      }
    }
  `: ""}
`;
